import type { HelpPage } from './pages.js';
import { parsePage } from './pages.js';
import { indexPages } from './search.js';

/**
 * Every help page, bundled into the POS (docs/HELP.md).
 *
 * Read at build time from `apps/pos/help/`, so the help a store sees is always
 * the help written for the code it is running — staging's for staging's,
 * production's for production's — and it needs no network to open. A page
 * that is not well-formed fails the build here, naming the file.
 */
const sources = import.meta.glob('../../../help/**/*.md', {
  query: '?raw',
  import: 'default',
  eager: true,
}) as Record<string, string>;

export const HELP_PAGES: readonly HelpPage[] = Object.entries(sources)
  .map(([path, source]) => parsePage(path.slice(path.lastIndexOf('/') + 1), source))
  .sort((a, b) => a.title.localeCompare(b.title));

export const HELP_INDEX = indexPages(HELP_PAGES);

export const HELP_BY_ID: ReadonlyMap<string, HelpPage> = new Map(
  HELP_PAGES.map((page) => [page.id, page]),
);
